const hideElement = condition => ({
  display: condition ? 'none' : 'block',
})

export default hideElement
